// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uh8br{display:flex;flex-direction:column;gap:20px;align-items:flex-start}.MglzR{margin:8px;width:70%;display:flex;align-items:center;gap:12px}.vyBfY{margin:8px}.QEmwb{display:flex;flex-direction:column;align-items:flex-start}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `Uh8br`,
	"copyApiKeyContainer": `MglzR`,
	"goToContainer": `vyBfY`,
	"stepsContainer": `QEmwb`
};
export default ___CSS_LOADER_EXPORT___;
